import axios from "axios";

export default axios.create({
  baseURL: "https://admin.pandamastersweeps.com",
  headers: {
    "Content-type": "application/json"
  }
});